export default function Msg()
{
  const name = localStorage.getItem("username");

  const onclick = () =>
  {
    const name = prompt("Podaj swoję imię:")

    if (name)
    {
        localStorage.setItem("username", name);
        window.location.reload();
    }
  }
  return (
       
        <div>
          <button onClick={onclick}  style={{padding: "10px 20px",backgroundColor: "grey",color: "white",border: 
          "none",borderRadius: "5px",cursor: "pointer",fontWeight: "bold", transition: "background-color 0.3s"
  }}>Przedstaw się</button>
          <h2>Witaj {name}!</h2>
        </div>
      )
}
    
    
  
  
